import React = require("react");
import "./VeboxDanfossLayout.scss";
import {veboxDefaultTheme} from "../../index";
import {ThemeProvider} from "@vebox/etui-system";

// interface VeboxRedDanfossLayoutProps {
//     copyright: string;
// }

// const VeboxFooter = ({text}) => {
//     return (
//         <footer className={"vebox-danfoss-layout-footer"}>
//             <p className="footer-link">{text}</p>
//         </footer>
//     );
// };

const VeboxHeader: React.FunctionComponent<{}> = () => {
    return (
        <div draggable="false">
            <img draggable="false" className="logoPayoff" src="/vebox/images/logoBig.png" alt="Logo"/>
        </div>
    );
};


export const VeboxDanfossLayout: React.FC<{}> = (props) => {
    return (
        <ThemeProvider theme={veboxDefaultTheme}>
            <div className={"vebox-danfoss-layout-page red-background"}>
                <VeboxHeader/>
                {props.children}
            </div>
        </ThemeProvider>
    );
}
